import * as React from "react";
import { Typography, Container, Box } from "@material-ui/core";
import { SecureArea } from "../components/authentication/SecureArea";
import { MemberPermission } from "../services/MemberService";
import { AuctionStatusReportContainer } from "../components/reporting/AuctionStatusReportContainer";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../services/TelemetryService";

const AuctionStatusReporting = () => (
  <Container maxWidth={"lg"} fixed>
    <SecureArea memberPermission={MemberPermission.BucketAdmin}>
      <Typography variant="h4" color="primary" gutterBottom>
        Auction status report
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Create an export for auction status reports. The auction status report includes information on the auctions currently in the status of
        Incomplete, Holding or Live.
      </Typography>
      <Box mt={4}>
        <AuctionStatusReportContainer />
      </Box>
    </SecureArea>
  </Container>
);

export default withAITracking(reactPlugin, AuctionStatusReporting, "AuctionStatusReporting");
